import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { useLocation, useParams } from 'react-router-dom';
import compose from 'ramda/es/compose';
import HomePage from './homePage.component';
import { HomePageActions } from '../../reducers/page/homePage/homePage.redux';
import { MenuActions } from '../../reducers/menu/menu.redux';
import {
  selectIsHeroPresent,
  selectIsHeroWithTitlePresent,
} from '../../reducers/page/page.selectors';
import { selectCurrentHomePageData } from '../../reducers/page/homePage/homePage.selectors';

const mapStateToProps = createStructuredSelector({
  pageData: selectCurrentHomePageData,
  isHeroPresent: selectIsHeroPresent,
  isHeroWithTitlePresent: selectIsHeroWithTitlePresent,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setCurrentPage: HomePageActions.setCurrentHomePage,
      fetchPage: HomePageActions.fetchHomePage,
      setCategoryMenuVisible: MenuActions.setCategoryMenuVisible,
      setHeaderStyle: MenuActions.setHeaderStyle,
    },
    dispatch,
  );

const Connected = compose(connect(mapStateToProps, mapDispatchToProps))(HomePage);

export default props => {
  const routerLocation = useLocation();
  const { slug, splat } = useParams();
  // Don't overwrite slug with passed in prop.
  return <Connected slug={slug} splat={splat} {...props} location={routerLocation} />;
};
